__turbopack_context__.v({
  "content": "TextContent-module-scss-module__NPclRq__content",
  "contentCenter": "TextContent-module-scss-module__NPclRq__contentCenter",
  "contentLimitWidth": "TextContent-module-scss-module__NPclRq__contentLimitWidth",
  "contentTextSizeLg": "TextContent-module-scss-module__NPclRq__contentTextSizeLg",
  "contentTextSizeMd": "TextContent-module-scss-module__NPclRq__contentTextSizeMd",
  "contentTextSizeSm": "TextContent-module-scss-module__NPclRq__contentTextSizeSm",
  "contentTextSizeSmMd": "TextContent-module-scss-module__NPclRq__contentTextSizeSmMd",
  "contentTextSizeXl": "TextContent-module-scss-module__NPclRq__contentTextSizeXl",
  "fade-in": "TextContent-module-scss-module__NPclRq__fade-in",
  "no-transform": "TextContent-module-scss-module__NPclRq__no-transform",
  "rotate": "TextContent-module-scss-module__NPclRq__rotate",
});
